import {GoogleAnalyticsService} from './service/utils/google-analytics.service';
import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private _router: Router,
    private _gaServ: GoogleAnalyticsService) {

  }

  ngOnInit(): void {
    this._router.events.filter(event => event instanceof NavigationEnd).subscribe(
      (params: any) => {
        this._gaServ.sendPageView();
      }
    );
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/app.component.ts